module.exports = __webpack_public_path__ + "static/img/tv4.43adedf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/companies/marketmaker/assets/tv4.jpg
// module id = i6A5
// module chunks = 1